import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { ref, onMounted, onUnmounted } from 'vue';
import screenfull from 'screenfull';

// 是否全屏

export default {
  __name: 'index',
  setup(__props) {
    const isFullscreen = ref(false);

    // 监听变化
    const change = () => {
      isFullscreen.value = screenfull.isFullscreen;
    };

    // 切换事件
    const onToggle = () => {
      screenfull.toggle(); // 默认是浏览器视口全屏展示
    };

    // 设置侦听器
    onMounted(() => {
      screenfull.on('change', change);
    });

    // 删除侦听器
    onUnmounted(() => {
      screenfull.off('change', change);
    });
    return (_ctx, _cache) => {
      const _component_svg_icon = _resolveComponent("svg-icon");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_svg_icon, {
        id: "guide-full",
        icon: isFullscreen.value ? 'exit-fullscreen' : 'fullscreen',
        onClick: onToggle
      }, null, 8, ["icon"])]);
    };
  }
};